/**
 * Does this clipboard payload carry a real HTML table?
 *
 * Excel puts BOTH a bitmap of the copied range and a `text/html` <table> on the
 * clipboard. OneNote puts only the table. The editor's paste handler consumes any
 * image before TipTap ever inspects the HTML, so an Excel paste silently became a
 * screenshot while an identical-looking OneNote paste became an editable grid.
 * Detecting the table is what lets us ask which the writer wanted.
 *
 * Matches `<table` followed by a tag boundary, so the word "table" in prose, a
 * `data-tablet` attribute, or a `<tablet>` element cannot fool it.
 */
export function clipboardHasTable(html: string): boolean {
  return /<table[\s/>]/i.test(html);
}
